<div class="withdrawal-card" [ngClass]="{ 'withdrawal-card--toggled': toggled }">
    <div
        class="header"
        (click)="toggle()"
        (keydown.space)="toggle()"
        (keydown.enter)="toggle()"
        tabindex="0"
    >
        <div class="header-layout">
            <div class="type">
                {{ ('global.' + investmentType) | translate }}
            </div>
            <div class="name-container">
                &#34;
                <div class="name">
                    {{ withdrawal.portfolioName }}
                </div>
                &#34;
            </div>
        </div>

        <div class="phone-content arrow-container">
            @if (!toggled) {
              <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18 }"></svg-icon>
            } @else {
              <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(180deg)' }"></svg-icon>
            }
        </div>
    </div>

    <div class="mobile-layout" [ngClass]="{ 'mobile-layout--toggled': toggled }">
        <hr class="divider">

        <div class="label">
            {{ 'money.withdrawalCard.value' | translate }}
        </div>
        <div class="value value--big">
            {{ withdrawal.value | price:'CZK' }}
        </div>

        <div class="cols-layout">
            <div class="left">
                <div class="label">
                    {{ 'money.withdrawalCard.frequency' | translate }}
                </div>
                <div class="value">
                    {{ (withdrawal.frequency === regularWithdrawalFrequencies.MONTHLY ? 'money.withdrawalForm.frequencyMonthly' : 'money.withdrawalForm.frequencyQuaterly') | translate }}
                </div>

                <div class="label">
                    {{ 'money.withdrawalCard.nextWithdraw' | translate }}
                </div>
                <div class="value">
                    {{ nextExecutionDate }}
                </div>

                <div class="label">
                    {{ 'money.withdrawalCard.alreadyPaid' | translate }}
                </div>
                <div class="value">
                    {{ withdrawal.sumOfWithdrawals | price:'CZK' }}
                </div>
            </div>

            <div class="right">
                <div class="label">
                    {{ 'money.withdrawalCard.validTo' | translate }}
                </div>
                <div class="value">
                    {{ withdrawal.validTo  ? (withdrawal.validTo | date:'d. M. y') : '-' }}
                </div>
            </div>
        </div>

        <div class="mt-4 text-center">
            <libero-button
                label="{{ 'money.withdrawalCard.cancelRegularWithdrawalBtn' | translate }}"
                btnClasses="btn--secondary btn--card-action btn--wide"
                svgIcon="trash"
                [iconWidth]="16"
                (click)="openRegularWithdrawCancelModal()"
            ></libero-button>
        </div>
    </div>
</div>
